import { Chip, Divider, Grid, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography, tableCellClasses } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { fetchInvoices } from '../../store/invoiceStore/invoiceThunk';
import { fetchReport } from '../../store/reportStore/reportThunk';

import styled_ from "@emotion/styled";
import LoadingButton from '@mui/lab/LoadingButton';
import moment from 'moment';
import { ApiStatus } from "../../utils/api.types";
import { Utils, VocuherCategory } from "../../utils/common-utils";
import Filters from '../Filters/Filters';
import generatePDF, { Resolution, Margin, Options } from "react-to-pdf";


const StyledTableCell = styled_(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#eaecf0',
    color: '#000',
    border: '0.75px solid #d9d4d4',
    margin: 0,
    padding: 5,
    fontSize: '9pt',
    paddingLeft: '15px !important',
    fontWeight: 600,
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: '9pt',
    fontWeight: 'normal',
    color: '#292d35',
    padding: 5,
    border: '0.75px solid #d9d4d4',
    paddingLeft: '15px !important',
    margin: 0
  },
}));

const StyledTableRow = styled_(TableRow)(({ theme }) => ({
  // '&:nth-of-type(even)': {
  //   backgroundColor: '#fbfbfb',
  //   // border: '0.5px dashed #9da7b7',
  // },
  // '&:nth-of-type(odd)': {
  //   backgroundColor: '#e9ecf1',
  //   // border: '0.5px dashed #9da7b7',
  // },
  // // hide last border
  // '&:last-child td, &:last-child th': {
  // },
}));


interface PartyReportDataProps {
  type: string;
}
const PartyLedger: FC<PartyReportDataProps> = (props) => {
  const dispatch = useAppDispatch();
  const { invoices, status } = useAppSelector(state => state.invoices);
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const [filters, setFilters] = useState('');
  const [filterData, setFilterData] = useState<any>();

  const filterOnChangeHandler = (data: any) => {
    setFilters(data);
  };
  const filterdOnChangeHandler = (data: any) => {
    setFilterData(data);
  };

  useEffect(() => {
    const { _id: id } = selectedAccount;
    if (filters) {
      dispatch(fetchInvoices({ accountId: id, type: VocuherCategory.SALE, params: filters }));
    }

  }, [dispatch, selectedAccount, filters]);

  const additionalChargesSum = (invoice: any) => {
    let _additionalCharges;
    let initialSum = 0;
    if (invoice.additionalCharges && invoice.additionalCharges.charges && invoice.additionalCharges.charges.length > 0) {
      _additionalCharges = invoice.additionalCharges.charges.reduce((previousValue: any, currentValue: any) => previousValue + Number(currentValue.value), initialSum);
    } else {
      _additionalCharges = 0;
    }
    return _additionalCharges;
  };



  const options: Options = {
    filename: `ledger_report_${Date.now()}.pdf`,
    method: "save",
    // default is Resolution.MEDIUM = 3, which should be enough, higher values
    // increases the image quality but also the size of the PDF, so be careful
    // using values higher than 10 when having multiple pages generated, it
    // might cause the page to crash or hang.
    resolution: Resolution.NORMAL,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.MEDIUM,
      // default is 'A4'
      format: "A4",
      // default is 'portrait'
      // orientation: "landscape"
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/jpeg",
      qualityRatio: 1
    },
    // Customize any value passed to the jsPDF instance and html2canvas
    // function. You probably will not need this and things can break,
    // so use with caution.
    overrides: {
      // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
      pdf: {
        compress: true
      },
      // see https://html2canvas.hertzen.com/configuration for more options
      canvas: {
        useCORS: true
      }
    }
  };

  // you can also use a function to return the target element besides using React refs
  const getTargetElement = () => document.getElementById("pdfContainer");

  const downloadPdf = () => generatePDF(getTargetElement, options);


  return (
    <>
      <Grid container p={0} spacing={2} position={'fixed'} mt={-2} zIndex={0}>
        <Grid item xs={8}>
          <Box sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#fff' }}>
            <Grid container>
              <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, pt: 1.5, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                <div style={{ float: 'right', marginTop: -5, marginRight: -5 }}>
                  {/* <CustomBreadcrumbs/> */}
                </div>
                <IconButton
                  style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 15, marginLeft: -5 }}
                  size='small' >
                  <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
                </IconButton>
                <h3 style={{ marginTop: -1, fontWeight: 600 }}>{'Party Ledger'}</h3>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2} p={0.5} mb={1} pt={9}>
        {/* Need this container to keep show filter on screen */}
      </Grid>
      <Grid container spacing={2} >
        <Grid item xs={12}>
          <Box sx={{ width: '100%' }} className={'c-card2'}>
            <Grid container p={2} >
              <Grid xs={10} >
                <Filters type={VocuherCategory.SALE} filterHandler={filterOnChangeHandler} selectedFilters={filterdOnChangeHandler} />
              </Grid>
              {/* keep the empty grid for space*/}
              {/* <Grid xs={2} pr={2}></Grid> */}
              <Grid xs={2} >
                <LoadingButton
                  className={'buttonContainedRoot'}
                  size='small'
                  type="button"
                  name={'submit'}
                  // onClick={() => handleShareReportToEmail()}
                  onClick={downloadPdf}
                  loading={status === ApiStatus.LOADING}
                  // style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7, marginRight: 10 }}
                  variant="contained"
                >
                  Download PDF
                </LoadingButton>
                {/* <Button
                  onClick={() => handleShareReportToEmail()}
                  size='small'
                  variant="contained"
                  style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7 }}>
                  Send To Email
                </Button> */}
              </Grid>
            </Grid>
            <div style={{ marginBottom: 12 }} id='pdfContainer'>
              <Grid container p={2} >
                <Grid xs={12} style={{ textAlign: 'center' }}>
                  <Typography style={{
                    // textDecoration: 'underline',
                    // textUnderlinePosition: 'under',
                    // textUnderlineOffset: '15px',
                    fontSize: 30,
                    fontWeight: 600,
                    // paddingBottom: 10
                  }}>
                    {`Party Ledger Report`}
                  </Typography>
                  <Typography style={{
                    fontSize: 22,
                    fontWeight: 500
                  }}>
                    {(filterData  && filterData.selectedClient) ? `(${filterData.selectedClient.name})` : ''}
                  </Typography>
                  <Typography style={{
                    fontSize: 14,
                    fontWeight: 500
                  }}>
                    {(filterData && filterData.periodString) ? `${filterData.periodString}` : ''}
                  </Typography>
                  
                </Grid>

              </Grid>
              <Table stickyHeader sx={{ minWidth: 700, marginBottom: '100px' }} size='small' aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell >Date</StyledTableCell>
                    <StyledTableCell>Type</StyledTableCell>
                    <StyledTableCell ># No</StyledTableCell>
                    <StyledTableCell >Customer</StyledTableCell>
                    <StyledTableCell>TAX %</StyledTableCell>
                    <StyledTableCell>TOTAL</StyledTableCell>
                    <StyledTableCell>STATUS</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(invoices && invoices.length > 0) ? invoices.map((row: any, index) =>
                    <>
                      <StyledTableRow key={index}>
                        <StyledTableCell>{row.date != undefined && row.date != '' ? moment(row.date).format("DD MMM YYYY") : moment(row.createDate).format("DD MMM YYYY")}</StyledTableCell>
                        <StyledTableCell>{row.voucherType}</StyledTableCell>
                        {/* <StyledTableCell>{row.gstin}</StyledTableCell> */}
                        <StyledTableCell>{row.invoiceNumber}</StyledTableCell>
                        <StyledTableCell>{row.client.name}</StyledTableCell>
                        <StyledTableCell>{Utils.formatNumber(parseFloat(row.tax1) + parseFloat(row.tax2) + parseFloat(row.tax3) || '0', true, true)}</StyledTableCell>
                        <StyledTableCell>
                          {Utils.formatNumber(parseFloat(row.amount + additionalChargesSum(row)).toFixed(2) || '0')}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.status == 'DRAFT' && 'Draft'}
                          {row.status == 'PENDING' && 'Pending'}
                          {row.status == 'INVOICED' && 'Invoiced'}
                          {row.status == 'PAID' && 'Paid'}
                          {row.status == 'PARTIALLY_PAID' && 'Partially Paid'}
                          {row.status == 'OVER_PAID' && 'Over Paid'}
                        </StyledTableCell>
                        {/* <StyledTableCell>{e.placeOfSupply}</StyledTableCell> */}
                        {/* <StyledTableCell>{e.client.name}</StyledTableCell> */}


                      </StyledTableRow>

                    </>
                  ) :
                    ''
                  }
                </TableBody>
              </Table>
            </div>
          </Box>

        </Grid>
      </Grid>
    </>
  );
}
export default PartyLedger;